import { InformationCircleIcon } from "@dealer-center/core-components";
import styled, { css } from "styled-components";

export const StyledInput = css<{
  imported: boolean;
  importExists: boolean;
}>`
  margin-bottom: ${props => (props.importExists ? "0px" : undefined)};
  & > input.form-control {
    border-color: ${props => (props.imported ? "#2b6bdd" : undefined)};
    border-width: ${props => (props.imported ? "2px;" : undefined)};
  }
`;
export const StyledImportedText = styled.span`
  margin-left: 4px;
`;
export const StyledIconInfoOutline = styled(InformationCircleIcon)``;
export const StyledImport = styled.div`
  display: flex;
  color: #2b6bdd;
  margin-bottom: 12px;
`;
export const StyledInputWrapper = styled.div`
  padding-bottom: 8px;
`;
